import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../services/firestore.service';
import { Router } from '@angular/router';
import { SeoService } from '../services/seo.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  public swiperConfig: SwiperConfigInterface;
  public lang;
  public menu;

  constructor(
    public fs: FirestoreService,
    public router: Router,
    private seo: SeoService,
  ) {
    const temp = this.router.url.split('/');
    this.lang = temp[1];
    this.fs.getMenu('listMenu', this.lang).valueChanges().subscribe(data => {
      // @ts-ignore
      this.menu = data.menu;
    });
  }

  ngOnInit() {
    this.swiperConfig = {
      autoplay: true, // Autoplay option having value in milliseconds
      initialSlide: 3, // Slide Index Starting from 0
      slidesPerView: 1, // Slides Visible in Single View Default is 1
      pagination: true, // Pagination Class defined
      spaceBetween: 0 // Space between each Item

    };
  }

}
